import { GraphSchema } from '@camelot/server';

export interface CalendarSyncConfiguration {
  id: string;
  clientTenantId: string;
  clientId: string;
  clientSecret: string;
}

export interface CalendarSyncConfigurationCreationPayloadInput {
  clientTenantId: string;
  clientId: string;
  clientSecret: string;
}

export interface CalendarSyncConfigurationModifierPayloadInput {
  id: string;
  clientTenantId: string;
  clientId: string;
  clientSecret: string;

  updatedFields: string[];
}

export const calendarSyncConfigurationProps = new GraphSchema<CalendarSyncConfiguration>([
  'id',
  'clientTenantId',
  'clientId',
  'clientSecret',
]);
